import { useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { StoreState } from '@root/types';
import { getCurrentUser } from '@store/selectors';
import { useListingSearchCriteria } from '@components/layouts/Truva/ListingSearch/utils';
import { Button } from '@components/shared';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import s from './MobileSearchCriteriaBar.module.less';
import { FilterPillOptions } from './FilterPill/FilterPill';
import SaveSearch from '../SaveSearch';
import ListingSearchFiltersPanel from '../Filters/ListingSearchFiltersPanel';

type SearchCriteriaBarProps = {
  options: FilterPillOptions[];
  onFilterPillClick: (filterkey: string) => void;
  removeAll: () => void;
};

type ReduxProps = ConnectedProps<typeof connector>;

const mapStateToProps = (state: StoreState) => ({
  currentUser: getCurrentUser(state),
});

const connector = connect(mapStateToProps);

const SearchCriteriaBar = ({
  options,
  onFilterPillClick,
  removeAll,
  currentUser,
}: SearchCriteriaBarProps & ReduxProps) => {
  const openFiltersButtonRef = useRef<HTMLButtonElement>(null);
  const criteria = useListingSearchCriteria();
  const [filterPanelIsOpen, setFilterPanelIsOpen] = useState(false);
  const userLoggedIn = !!currentUser;

  const noOptions = options.length < 1;

  return (
    <div data-testid="searchCriteriaBar" className={s.wrapper}>
      <Button
        buttonRef={openFiltersButtonRef}
        data-testid="openFiltersButton"
        className={classNames(s.openFiltersButton, noOptions && s.noOptions)}
        type="tertiary"
        size="small"
        icon="filters"
        onClick={() => setFilterPanelIsOpen(true)}
      >
        {noOptions ? '' : `(${options.length})`}
      </Button>
      <div className={s.searchControls}>
        {userLoggedIn && <SaveSearch disabled={noOptions} criteria={criteria} />}
      </div>
      {createPortal(
        <ListingSearchFiltersPanel
          isOpen={filterPanelIsOpen}
          closePanel={() => {
            setFilterPanelIsOpen(false);
            openFiltersButtonRef?.current?.focus();
          }}
          removeAll={removeAll}
          activeFilters={options}
          onFilterPillClick={onFilterPillClick}
        />,
        document.body,
      )}
    </div>
  );
};

export default connector(SearchCriteriaBar);
